import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login/index'
import home from '@/views/home/index'
import device from '@/views/device/index'
import user from '@/views/user/index'
import admin from '@/views/admin/index'
import data from '@/views/data/index'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: login
        },
        {
            path: '/home',
            name: 'home',
            component: home
        },
        {
            path: '/device',
            name: 'device',
            component: device
        },
        {
            path: '/user',
            name: 'user',
            component: user
        },{
            path: '/admin',
            name: 'admin',
            component: admin
        },{
            path: '/data',
            name: 'data',
            component: data
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js